<template>
    <div class="main_app">   
        <Header />
        <div class="main_container main_app_container">
            <div class="main_app_item main_app_left">
                <router-view></router-view>
            </div>
<!--            <search-asset class="mb" :class="openSearchAssets ? 'active' : ''" />-->
<!--            <select-account class="sm" :class="this.$store.state.openSelectAccount ? 'active' : ''"/>-->
<!--            <select-exchange class="sm" :class="this.$store.state.selectExchangeOpened ? 'active' : ''"/>-->
<!--            <div class="main_app_item main_app_right">-->
<!--                <Settings />-->
<!--                <search-asset :class="openSearchAssets ? 'active' : ''" />-->
<!--                <select-account :class="this.$store.state.openSelectAccount ? 'active' : ''"/>-->
<!--                <select-exchange :class="this.$store.state.selectExchangeOpened ? 'active' : ''"/>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
import Header from "@/components/header/HeaderMain.vue";
import Settings from '@/views/Settings.vue';
import SearchAsset from './SearchAsset.vue';
import SelectAccount from './SelectAccount.vue';
import SelectExchange from './SelectExchange.vue';

export default {
    name: "HomeDefault",
    components: {
        Header,
        Settings,
        SearchAsset,
        SelectAccount,
        SelectExchange
    },
    computed: {
        authToken () {
            return this.$store.state.authToken
        },
        openSearchAssets () {
            return this.$store.state.openSearchAssets;
        }
    },
    created() {
        if (this.authToken == null) {
            this.$router.push({name: 'AuthIn'}) 
        }
    }
}
</script>

<style>

</style>